import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Send_SMS extends PureComponent {
  render() {
    return (
      <div className="row" id="send_sms">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>SMS Send</h2>
              <p>
                To send a text message you need the recipient’s mobile number
                including the country code. In the event of an attempt to send a
                text message without a country code the system will
                automatically add the country code of your data region. Text
                messaging standards change from country to country. Most
                countries support 140 character text messages however some will
                only support 110. Try to keep your messages short and test
                thoroughly with your user group.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Send SMS Example</h2>
              <p>
                This example sends a text message to a fake mobile number in the
                uk +4488000000.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePOST">POST</span> - https://
                <span className="jsonY">example</span>
                .api.nexoid.com/v1/sms/send
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"sms"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"number"</span>:{" "}
                  <span className="jsonY">"+4488000000"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"message"</span>:{" "}
                  <span className="jsonY">"Test text message"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"number"</span>:{" "}
                  <span className="jsonY">"+4488000000"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"message"</span>:{" "}
                  <span className="jsonY">"Test text message"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"sent"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Send_SMS;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Send_SMS.js